/** 외부 승인 화면으로 현재 탭을 이동한다. 별도 함수로 둬 테스트가 실제 탐색 없이 검증한다. */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
